<template>
    <div class="na-form">
        <div v-if="post" class="left">


            <div class="dx-fieldset">
                <div class="dx-field">
                    <div class="dx-field-label">Id:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.HepId' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Name:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.HepName' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Title:</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='post.HepTitle' />
                    </div>

                </div>


                <div class="dx-field">
                    <div class="dx-field-label">Start Page Text:</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='post.HepStartPageText' />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Show on Start Page:</div>
                    <div class="dx-field-value">
                        <DxCheckBox v-model:value='post.HepShowOnStartPage' />
                    </div>
                </div>
                <div class="dx-field ">
                    <div class="dx-field-label">Quick Help:</div>
                    <DxHtmlEditor class="html-dx-field" v-model:value="post.HepQuickHelp"
                                  :value-type="editorValueType">
                        <DxToolbar>
                            <DxItem name="undo" />
                            <DxItem name="redo" />
                            <DxItem name="separator" />
                            <DxItem :accepted-values="sizeValues"
                                    name="size" />
                            <DxItem :accepted-values="fontValues"
                                    name="font" />
                            <DxItem name="separator" />
                            <DxItem name="bold" />
                            <DxItem name="italic" />
                            <DxItem name="strike" />
                            <DxItem name="underline" />
                            <DxItem name="separator" />
                            <DxItem name="alignLeft" />
                            <DxItem name="alignCenter" />
                            <DxItem name="alignRight" />
                            <DxItem name="alignJustify" />
                            <DxItem name="separator" />
                            <DxItem name="color" />
                            <DxItem name="background" />
                            <DxItem name="link" />
                            <DxItem name="image" />
                            <DxItem name="separator" />
                            <DxItem name="clear" />
                            <DxItem name="codeBlock" />
                            <DxItem name="blockquote" />
                            <DxItem name="separator" />
                            <DxItem name="insertTable" />
                            <DxItem name="deleteTable" />
                            <DxItem name="insertRowAbove" />
                            <DxItem name="insertRowBelow" />
                            <DxItem name="deleteRow" />
                            <DxItem name="insertColumnLeft" />
                            <DxItem name="insertColumnRight" />
                            <DxItem name="deleteColumn" />
                        </DxToolbar>
                    </DxHtmlEditor>


                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Start Page Header:</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='post.HepStartPageHeader' />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Start Page Text:</div>
                    <div class="dx-field-value">
                        <DxTextBox v-model:value='post.HepStartPageText' />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Created on:</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='post.HepCreatedOn' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Created by:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.HepCreatedBy' :readOnly="true" />
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Changed on:</div>
                    <div class="dx-field-value">
                        <DxDateBox :value='post.HepChangedOn' :readOnly="true" />
                    </div>

                </div>
                <div class="dx-field">
                    <div class="dx-field-label">Changed by:</div>
                    <div class="dx-field-value">
                        <DxTextBox :value='post.HepChangedBy' :readOnly="true" />
                    </div>
                </div>


                <div class="na-buttons-row">

                    <div>
                        <DxButton text="Save"
                                  type="default"
                                  styling-mode="contained"
                                  @click="onSaveClick()"
                                  onmouseover="this.style.backgroundColor='#006db9'" />
                    </div>
                    <div>
                        <DxButton text="Delete"
                                  type="default"
                                  styling-mode="contained"
                                  @click="onDeleteClick()"
                                  onmouseover="this.style.backgroundColor='#006db9'" />
                    </div>
                    <div>
                        <DxButton text="Close"
                                  type="default"
                                  styling-mode="outlined"
                                  @click="onCloseClick()" />
                    </div>
                    <div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    // @ is an alias to /src

    import { DxTextBox/*, DxTextArea*/ } from 'devextreme-vue';
    import { confirm, alert } from "devextreme/ui/dialog";
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxDateBox } from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import {
        DxHtmlEditor,
        DxToolbar,
        DxItem
    } from 'devextreme-vue/html-editor';
    import $ from 'jquery';
    import '../assets/detailForm.less';
    const baseUri = "WebApi.asmx/api/HelpEntryService";
    export default {
        name: 'HelpEntryDetail',
        components: {

            DxButton,
            DxTextBox
            /*       DxTextArea*/,
            DxDateBox,
            DxHtmlEditor,
            DxToolbar,
            DxItem,
            DxCheckBox

        },
        data() {
            return {
                post: null,
                files: []
            };
        },
        created: function () {
            axios
                .get(baseUri + '/GetDetailVx')
                .then(res => {
                    this.post = res.data.data

                })
        },
        methods: {
            onCloseClick() {
                $("form").attr("action", window.location.pathname + "?action=cancel").submit();
            },
            onSaveClick() {
                var formData = new FormData()
                formData.append("data", JSON.stringify(this.post))
                axios
                    .post(baseUri + '/SaveDetail', formData)
                    .then(res => {
                        if (res.data.success) { notify(`The changes were saved successfully`); }
                        else { alert(`error: ${res.data.errorMessage}`) }

                    })
            },
            onDeleteClick() {
                let result = confirm("do you really want to delete this record?", "Confirm delete");
                result.then((dialogResult) => {
                    if (dialogResult) {
                        var formData = new FormData()
                        formData.append("data", JSON.stringify(this.post))
                        axios
                            .post(baseUri + '/Delete', formData)
                            .then(res => {
                                if (res.data.success) {
                                    notify(`The record has been successfully deleted`);
                                    $("form").attr("action", window.location.pathname + "?action=cancel").submit();
                                }
                                else { alert(`error: ${res.data.errorMessage}`) }

                            })
                    }


                });


            },
            onClick(e) {
                const buttonText = e.component.option('text');
                notify(`The ${this.capitalize(buttonText)} button was clicked`);
            },
            capitalize(text) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }
        }
    }


</script>
<style>
</style>
